import {createAsyncThunk} from '@reduxjs/toolkit'
import {
  FetchLicenseByIdRequest,
  UpdateLicenseRequest,
  FetchLicensesRequest,
  CreateLicenseRequest,
  DeleteLicenseRequest,
  SuspendLicenseRequest,
  ActivateLicenseRequest,
} from './types'
import {AxiosError} from 'axios'
import {ResponseError} from '../commonTypes'
import {License} from '../../../models'
import axios from 'axios'
import {
  fetchLicensesUrl,
  fetchLicenseByIdUrl,
  createLicenseUrl,
  updateLicenseUrl,
  deleteLicenseUrl,
  suspendLicenseUrl,
  activateLicenseUrl,
} from '../../api'

export const fetchLicenses = createAsyncThunk(
  'license/fetch',
  async (payload: FetchLicensesRequest, {rejectWithValue}) => {
    try {
      const res = await axios.get(
        `${fetchLicensesUrl}?sortField=${payload.sortField}&sortOrder=${
          payload.sortOrder
        }&pageNumber=${payload.pageNumber}&pageCount=${payload.pageCount}${
          payload.search && payload.search.trim() !== '' ? '&search=' + payload.search.trim() : ''
        }`
      )
      const {licenses, totalPages, total} = res.data
      return {
        licenses,
        totalPages,
        total,
        success: true,
      }
    } catch (error) {
      const err: any = error as AxiosError
      const message = err.response?.data.fr
      return rejectWithValue({
        success: false,
        error: message || 'message',
      })
    }
  }
)

export const fetchLicenseById = createAsyncThunk(
  'license/fetchById',
  async (payload: FetchLicenseByIdRequest, {rejectWithValue}) => {
    try {
      const res = await axios.get(`${fetchLicenseByIdUrl}/${payload.id}`)
      const {license} = res.data
      return {
        license,
        success: true,
      }
    } catch (error) {
      const err: any = error as AxiosError
      const message = err.response?.data.fr
      return rejectWithValue({
        success: false,
        error: message || 'message',
      })
    }
  }
)

export const createLicense = createAsyncThunk(
  'license/create',
  async (payload: CreateLicenseRequest, {rejectWithValue}) => {
    try {
      const res = await axios.post(createLicenseUrl, payload)
      const {license} = res.data
      return {
        license,
        success: true,
      }
    } catch (error) {
      const err: any = error as AxiosError
      const message = err.response?.data.fr
      return rejectWithValue({
        success: false,
        error: message || 'message',
      })
    }
  }
)

export const updateLicense = createAsyncThunk(
  'license/update',
  async (payload: UpdateLicenseRequest, {rejectWithValue}) => {
    try {
      const res = await axios.post(updateLicenseUrl, payload)
      const {license} = res.data
      return {
        license,
        success: true,
      }
    } catch (error) {
      const err: any = error as AxiosError
      const message = err.response?.data.fr
      return rejectWithValue({
        success: false,
        error: message || 'message',
      })
    }
  }
)

export const deleteLicense = createAsyncThunk(
  'license/delete',
  async (payload: DeleteLicenseRequest, {rejectWithValue}) => {
    try {
      const res = await axios.post(deleteLicenseUrl, payload)
      const {license} = res.data
      return {
        license,
        success: true,
      }
    } catch (error) {
      const err: any = error as AxiosError
      const message = err.response?.data.fr
      return rejectWithValue({
        success: false,
        error: message || 'message',
      })
    }
  }
)

export const suspendLicense = createAsyncThunk(
  'license/suspend',
  async (payload: SuspendLicenseRequest, {rejectWithValue}) => {
    try {
      const res = await axios.post(suspendLicenseUrl, payload)
      const {license} = res.data
      return {
        license,
        success: true,
      }
    } catch (error) {
      const err: any = error as AxiosError
      const message = err.response?.data.fr
      return rejectWithValue({
        success: false,
        error: message || 'message',
      })
    }
  }
)

export const activateLicense = createAsyncThunk(
  'license/activate',
  async (payload: ActivateLicenseRequest, {rejectWithValue}) => {
    try {
      const res = await axios.post(activateLicenseUrl, payload)
      const {license} = res.data
      return {
        license,
        success: true,
      }
    } catch (error) {
      const err: any = error as AxiosError
      const message = err.response?.data.fr
      return rejectWithValue({
        success: false,
        error: message || 'message',
      })
    }
  }
)
